import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { OFFERS_ANCHOR, PRICE } from '../../data/offer';
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 640);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-154" data-mp="250nyw8f20ele">
      {visible && <motion.div initial={{
      y: 70,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 70,
      opacity: 0
    }} transition={{
      duration: 0.2,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-ink-line bg-ink/95 px-4 py-3 backdrop-blur md:hidden" data-id="element-155" data-mp="202w6ldahyqgo">
          <a href={OFFERS_ANCHOR} className="flex w-full items-center justify-center rounded-xl bg-cta px-5 py-4 font-display text-sm font-black uppercase tracking-wide text-white shadow-cta" data-id="element-156" data-mp="2nrffnv1df79t">
            Ver ofertas desde {PRICE.fromShort}
          </a>
        </motion.div>}
    </AnimatePresence>;
}